import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {useIsVerboseLocale} from '@app/hooks/use-verbose-locale';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useRouter} from 'next/router';

// Will be replaced with the internal link to the dedicated feature when ready
const FALLBACK_CTA_LINKS: {default: string; fr: string} = {
	default: 'https://newsroom-deezer.com/mydeezeryear-en/',
	fr: 'https://newsroom-deezer.com/mydeezeryear-fr/',
};

export const MdmMdySection: FunctionComponent = () => {
	const {locale} = useRouter();
	const {t} = useTranslation();
	const isVerboseLocale = useIsVerboseLocale();
	const fontSize = isVerboseLocale
		? {base: '3xl', sm: '5xl', xl: '6xl'}
		: undefined;
	const ctaLink =
		locale === 'fr' ? FALLBACK_CTA_LINKS.fr : FALLBACK_CTA_LINKS.default;

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2" fontSize={fontSize}>
						{t(
							'featureslandingpage_title_urmonthuryearurmusic_standalone-web',
							{
								ns: 'features',
							},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_urmusicdeservesstatrecaps_standalone-web',
							{
								ns: 'features',
							},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '310px', md: '100%'}}
					quality={90}
					sizes={{base: '100vw', md: '50vw'}}
					alt={'mdm-mdy'}
					src="eb6d2155547966733aa5c4242266c11f.jpg"
					aspectRatio="912/824"
					width={{base: '100%', md: '70%'}}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'mdm-mdy'}}
					href={ctaLink}
				>
					{t('generic_action_discovermore_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
